import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {metrics} from '~/vendor/metrics';

import {getAnchorStyle} from '~/selectors/ProductSelectors';

import DecorationTypeTips from '~/shared/components/DecorationTypeTips';

import oneColorDesignImg from '~/assets/images/embossing/one_color_design.png';
import gradientDesignImg from '~/assets/images/embossing/gradient_design.png';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const EmbossModal = ({dismiss}) => {
  const product = useSelector(getAnchorStyle);

  useEffect(() => {
    metrics.pageViewTag('/ndx/designtip/embossing');
  }, []);

  const handleProductLink = () => {
    metrics.pageViewTag('/ndx/designtip/embossing/browseproducts');
  };

  const handleClose = () => {
    metrics.pageViewTag('/ndx/designtip/embossing/close');
  };

  const handleDone = () => {
    metrics.pageViewTag('/ndx/designtip/embossing/confirm');
  };

  const handleHelpLink = () => {
    metrics.pageViewTag('/ndx/designtip/embossing/help');
  };

  return (
    <DecorationTypeTips
      customClasses="ndx-EmbossModal"
      title="Design Tips for Embossed Products"
      description="Embossing creates a raised image by stamping your design on the surface of your product using no ink colors. Your design is representative of the embossing technique. Stick to these recommendations when adding your design"
      oneColorDesignImage={oneColorDesignImg}
      gradientDesignImg={gradientDesignImg}
      product={product}
      dismiss={dismiss}
      callbackHandleClose={handleClose}
      callbackHandleDone={handleDone}
      callbackHandleHelpLink={handleHelpLink}
      callbackHandleProductLink={handleProductLink}
    />
  );
};

EmbossModal.displayName = 'EmbossModal';
const propTypes = {
  dismiss: PropTypes.func
};

EmbossModal.propTypes = propTypes;

export default EmbossModal;
